import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';
// import OnlineConsultBanner from './OnlineConsultBanner';

function Navbar() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const location = useLocation(); // Get the current route

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    // Handle Scroll Event to change navbar appearance when scrolling
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div>
           
            {/* Sticky Navbar */}
            <nav className={`fixed top-28 sm:top-12 left-0 w-full p-3 flex justify-between items-center text-white bg-opacity-100 z-50 
                ${isScrolled ? "bg-black text-white shadow-md" : "bg-black"}`}>
                
                <Link to="/">
                    <img src="image/astro_logo1.jpeg" alt="Astro-MahaMaya" className="h-14 w-20 ml-4 rounded-xl" fetchPriority="high" />
                </Link>

                {/* Desktop Navigation */}
                <div className="hidden md:flex space-x-6 mr-5">
                    <NavLink to="/" location={location} scrollToTop={scrollToTop}>Home</NavLink>
                    <NavLink to="/services" location={location} scrollToTop={scrollToTop}>Services</NavLink>
                    <NavLink to="/books" location={location} scrollToTop={scrollToTop}>Books</NavLink>
                    <NavLink to="/contact" location={location} scrollToTop={scrollToTop}>Contact Us</NavLink>
                    <NavLink to="/about-astrologer" location={location} scrollToTop={scrollToTop}>About Astrologer</NavLink>
                </div>

                {/* Mobile Menu Toggle */}
                <button className="md:hidden text-yellow-400 text-3xl z-50" aria-label="Open Menu" onClick={() => setMenuOpen(!menuOpen)}>
                    {menuOpen ? <FaTimes /> : <FaBars />}
                </button>
            </nav>

            {/* Mobile Menu */}
            {menuOpen && (
                <div className="fixed top-0 left-0 w-full h-full bg-black text-white bg-opacity-90 flex flex-col items-center justify-center space-y-6 transition-transform duration-300 md:hidden z-50">
                    <button className="absolute top-6 right-6 text-yellow-400 text-3xl" onClick={() => setMenuOpen(false)}>
                        <FaTimes />
                    </button>
                    <NavLink to="/" location={location} scrollToTop={scrollToTop} isMobile setMenuOpen={setMenuOpen}>Home</NavLink>
                    <NavLink to="/services" location={location} scrollToTop={scrollToTop} isMobile setMenuOpen={setMenuOpen}>Services</NavLink>
                    <NavLink to="/books" location={location} scrollToTop={scrollToTop} isMobile setMenuOpen={setMenuOpen}>Books</NavLink>
                    <NavLink to="/contact" location={location} scrollToTop={scrollToTop} isMobile setMenuOpen={setMenuOpen}>Contact Us</NavLink>
                    <NavLink to="/about-astrologer" location={location} scrollToTop={scrollToTop} isMobile setMenuOpen={setMenuOpen}>About Astrologer</NavLink>
                </div>
            )}
        </div>
    );
}

// ✅ Custom NavLink Component
const NavLink = ({ to, location, scrollToTop, isMobile, setMenuOpen, children }) => {
    const isActive = location.pathname === to;
    return (
        <Link
            to={to}
            className={`text-lg font-semibold transition px-3 py-2 rounded-md ${
                isActive ? "text-yellow-400 border-b-2 border-yellow-400" : "hover:text-yellow-400"
            }`}
            onClick={() => {
                scrollToTop();
                if (isMobile) setMenuOpen(false);
            }}
        >
            {children}
        </Link>
    );
};

export default Navbar;
